<div class="personal-info-container" *ngIf="userData">
  <div class="header">
    <h2>Informations personnelles</h2>
    <button mat-icon-button (click)="toggleEdit()" *ngIf="!isEditing">
      <mat-icon>edit</mat-icon>
    </button>
  </div>

  <mat-card>
    <mat-card-content>
      <!-- Loading spinner -->
      <div class="loading-spinner" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <!-- View mode -->
      <div class="info-view" *ngIf="!isEditing && !isLoading">
        <div class="info-item">
          <label>Nom public</label>
          <p>{{ userData.publicName }}</p>
        </div>
        <div class="info-item">
          <label>Email</label>
          <p>{{ userData.email }}</p>
        </div>
        <div class="info-item">
          <label>Téléphone</label>
          <p>{{ userData.telephone || 'Non renseigné' }}</p>
        </div>
        <div class="info-item">
          <label>Ville</label>
          <p>{{ userData.ville || 'Non renseigné' }}</p>
        </div>
        <div class="info-item">
          <label>Profession</label>
          <p>{{ userData.profession || 'Non renseigné' }}</p>
        </div>
        <div class="info-item">
          <label>Description</label>
          <p>{{ userData.description || 'Non renseigné' }}</p>
        </div>
      </div>

      <!-- Edit mode -->
      <form class="info-form" *ngIf="isEditing && !isLoading">
        <mat-form-field appearance="outline">
          <mat-label>Nom public</mat-label>
          <input matInput [(ngModel)]="userData.publicName" name="publicName" required>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput [(ngModel)]="userData.email" name="email" type="email" required>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Téléphone</mat-label>
          <input matInput [(ngModel)]="userData.telephone" name="telephone">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Ville</mat-label>
          <input matInput [(ngModel)]="userData.ville" name="ville">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Profession</mat-label>
          <input matInput [(ngModel)]="userData.profession" name="profession">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <textarea matInput [(ngModel)]="userData.description" name="description" rows="3"></textarea>
        </mat-form-field>

        <div class="form-actions">
          <button mat-button color="warn" (click)="cancelEdit()">Annuler</button>
          <button mat-raised-button color="primary" (click)="saveChanges()">Enregistrer</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>